import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import LogoMonoWhite from "scmp-app/components/plus/plus-logo/logo-mono-white.svg";

import IconScmpLogo from "./icon-scmp-logo.svg";

export const Placeholder = styled(IconScmpLogo)``;
export const PlusPlaceholderImage = styled(LogoMonoWhite)``;

export type ContainerProps = {
  $aspectRatio?: string;
  $aspectRatioDesktopUp?: string;
  $aspectRatioTabletUp?: string;
  $variant?: "plus" | undefined;
};
export const Container = styled.figure<ContainerProps>`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  block-size: 100%;

  background: ${props => (props.$variant === "plus" ? "#d3d3cc" : "#dedede")};

  ${Placeholder} {
    inline-size: 45%;
    block-size: 45%;
  }

  ${PlusPlaceholderImage} {
    inline-size: 80%;
    block-size: 50%;
  }

  ${props => css`
    ${props.$aspectRatio &&
    css`
      aspect-ratio: auto ${props.$aspectRatio};
    `};

    ${theme.breakpoints.up("tablet")} {
      ${props.$aspectRatioTabletUp &&
      css`
        aspect-ratio: auto ${props.$aspectRatioTabletUp};
      `};
    }

    ${theme.breakpoints.up("desktop")} {
      ${props.$aspectRatioDesktopUp &&
      css`
        aspect-ratio: auto ${props.$aspectRatioDesktopUp};
      `};
    }
  `}
`;
